import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  block: {
    borderRight: `1px solid ${theme.palette.background.main}`,
    height: "90%",
  },
}));
